import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import fr from './locales/fr/translation.json';
import pr from './locales/pr/translation.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr },
            pr: { translation: pr },

        },
        lng: localStorage.getItem('i18nextLng') || 'pr',
        fallbackLng: 'pr',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
